<template>
  <div
    class="score-text"
  >
    <span v-if="percentage <= 5">
      This job scores <strong class="score-good">in the top 5%</strong>
    </span>
    <span v-else-if="percentage <= 40">
      This job scores <strong :class="scoreClass">higher than {{ 100 - percentage }}%</strong>
    </span>
    <span v-else>
      This job scores
      <strong :class="scoreClass">lower than {{ Math.min(percentage, 95) }}%</strong>
    </span>
    of <strong>{{ tags }}</strong> jobs
    <template v-if="location">
      in <strong>{{ location }}</strong>
    </template>
  </div>
</template>
<script>
export default {
  name: 'RankingComponent',
  props: {
    scoreClass: {
      type: String,
      default: '',
    },
    percentage: {
      type: Number,
      default: null,
    },
    tags: {
      type: String,
      default: null,
    },
    location: {
      type: String,
      default: null,
    },
  },
};
</script>
<style scoped lang="less">
.score-text {
  font-size: 13px;
  margin: 24px;
  line-height: 17px;
}
.score-text strong {
  font-weight: 500;
}
.score-text :deep(.score-good) {
  color: @basic-green;
}
.score-text :deep(.score-near-good) {
  color: @basic-green;
}
.score-text :deep(.score-average) {
  color: @basic-blue;
}
.score-text :deep(.score-poor) {
  color: @basic-red;
}
.score-text :deep(.score-near-bad) {
  color: @basic-red;
}
.score-text :deep(.score-bad) {
  color: @basic-red;
}
.score-text :deep(.score-none) {
  color: #ccc;
}
</style>
